module.exports = "/_next/static/images/CollectDataTabs-1-lg-7ae19308165d649233191d44e1327de8.png";